import { defineCustomElement } from "vue";

import EmbeddableSellersList from "./EmbeddableSellersList.ce.vue";

const customElement = defineCustomElement(EmbeddableSellersList);
window.customElements.define("embeddable-sellers-list", customElement);

export { EmbeddableSellersList };
